import { Separator } from '@ais-ui/ui-core';

import { useLocalization } from '@ais-ui/locale-management';

import { useSettings } from '../SettingsProvider';
import { MessageForm } from './MessageForm';

export function SettingsMessagesPage() {
  const { messages } = useLocalization();
  const { settings } = useSettings();

  return (
    <div className="space-y-6 w-full">
      <div>
        <h3 className="text-2xl font-medium">
          {messages.settingsMessagesTitle}
        </h3>
        <p className="text-sm text-muted-foreground">
          {messages.settingsMessagesSubtitle}
        </p>
      </div>
      <Separator className="w-full" />
      <div className="flex items-center justify-between">
        <h3 className="text-lg font-medium">
          {messages.settingsMessagesListTitle}
        </h3>
      </div>
      <MessageForm />
    </div>
  );
}
